<template>
  <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-container" label-position="left"
           label-width="0px" v-loading="loading" element-loading-text="登陆验证中，请稍后..."
           element-loading-spinner="el-icon-loading">
    <h3 class="login_title">系统登录</h3>
    <el-form-item prop="username">
      <el-input type="text" v-model="loginForm.username" autofocus  placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="loginForm.password" placeholder="密码" @keyup.enter.native="submitClick"></el-input>
    </el-form-item>
    <el-form-item style="width: 100%">
      <el-button type="primary" @click.native.prevent="submitClick" style="width: 100%">登录</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
  import { Encrypt } from "@/utils/secret.js";
  export default{
    data(){
      return {
        rules: {
          username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
          password: [{required: true, message: '请输入密码', trigger: 'blur'}]
        },
        checked: true,
        loginForm: {
          username: '',
          password: ''
        },
        loading: false
      }
    },
    methods: {
      submitClick() {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            let _this = this;
            _this.loading = true;
            let form = {
              username: _this.loginForm.username,
              password: Encrypt(_this.loginForm.password)
            }
            
            this.postRequest('/api/hr/login', form).then(resp => {
              if (resp && resp.status == 200) {
                _this.$message({
                  type: resp.data.status,
                  message: resp.data.msg
                })
                let data = resp.data.data;
                _this.$store.commit('login', data);
                let path = _this.$route.query.redirect;
                _this.$router.replace({path: path == '/' || path == undefined ? '/home' : path});
              }
              _this.loading = false;
            });
          }
        })
      }
    }
  }
</script>
<style>
  .login-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .login_title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .login_remember {
    margin: 0px 0px 35px 0px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue